/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import styled from '@themes/theme'

const LiveVisualNoticeWrap = styled.div`
  display: flex;
  flex-flow: column;
  padding: 34px 0;
  background: ${props => props.theme.color.themeTxt};
  border-top: 1px solid ${props => props.theme.color.modalSubBg2};
  .txt {
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
    &:not(.point-color--orange--modal) {
      color: ${props => props.theme.color.modalTxt};
    }
    &:not(:last-of-type) {
      margin-bottom: 14px;
    }
  }
`

const LiveVisualNotice: React.FC = () => {
  return (
    <LiveVisualNoticeWrap>
      <p className="txt">
        제공하는 경기정보는 &lsquo;해외 데이터 협력업체&rsquo;에서<br/>
        제공하는 것으로 당사와 무관합니다.
      </p>
      <p className="point-color--orange--modal txt">
        실제 경기상황과 다를 수 있으므로,<br/>
        참고 자료로만 활용할 것을 권장합니다.
      </p>
      <p className="point-color--orange--modal txt">
        위 정보만 의존하여 발생되는 사항에 대하여<br/>
        책임이 없음을 안내합니다.
      </p>
      <p className="txt">
        위 내용을 유념하시어<br/>
        서비스 이용 부탁드립니다.
      </p>
    </LiveVisualNoticeWrap>
  )
}

export default observer(LiveVisualNotice)
